<!--
 * @Author: XiaoJun
 * @Date: 2023-02-25 10:00:42
 * @LastEditors: XiaoJun
 * @LastEditTime: 2023-02-25 10:08:51
 * @Description: 组件功能
 * @FilePath: /fd-yangpu-talent-client/src/components/blockTitle/index.vue
-->
<template>
  <div class="block_title" :class="{ has_padding: hasPadding }">
    <div class="title_text" :class="{ has_bar: hasBar }">
      <img :src="imgURL" alt="" v-if="imgURL" />
      <span class="pure_text">{{ title }}</span>
    </div>
    <div class="more">
      <slot name="more"></slot>
    </div>
    <div class="ml_auto">
      <slot name="right"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '默认标题'
    },
    hasPadding: {
      type: Boolean,
      default: false
    },
    fontSize: {
      type: String,
      default: '18px'
    },
    height: {
      type: String,
      default: '20px'
    },
    fontWeight: {
      type: String,
      default: '400'
    },
    color: {
      type: String,
      default: 'rgba(0, 0, 0, 0.65)'
    },
    // barColor: {//直接使用系统主题色
    //   type: String,
    //   default: '#2668db'
    // },
    imgURL: {
      // 目前只支持 require()导入的图片
      // eg  :imgURL="require('@/asd/ccc.png')"
      type: String,
      default: ''
    },
    // 支持背景图缩放 默认原图比例
    imgScale: {
      type: String,
      default: ''
    },
    hasBar: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>
<style lang="less" scoped>
.block_title {
  display: flex;
  align-items: center;
  &.has_padding {
    padding: 10px 0;
  }
  .title_text {
    font-size: 18px;
    color: #333;
    line-height: 24px;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    position: relative;
    .pure_text {
      z-index: 10;
      font-weight: 700;
    }
    &.has_bar {
      &::before {
        content: '';
        display: inline-block;
        width: 6px;
        height: 24px;
        background-color: #1492ff;
        margin-right: 6px;
        border-radius: 4px;
      }
    }
  }
  .more {
    height: 24px;
    display: flex;
    align-items: center;
  }
}
</style>
